<template>    
    <v-text-field v-bind="$attrs" v-model="displayValue" @keypress="format"></v-text-field>
</template>

<script>

import i18n from '../../plugins/i18n'

const locale = i18n.locale;
const { decimal, thousands, prefix } = locale === 'pt' ? { decimal: ',', thousands: '.', prefix: 'R$ ' } : { decimal: '.', thousands: ',', prefix: '$ ' };

export default {
    props: ["value", "hasPrefix"],
    computed: {
        displayValue: {
            get() {                                
                if (!this.value || this.value === 0)
                    return (this.hasPrefix === false ? '' : prefix ) + '0' + decimal + "00";
                
                let str = String(this.value).split('.');
                let newStr = '';
                let numberPart = str[0];                
                for (let index = numberPart.length - 1, indexDecimal = 1; index >= 0; index--, indexDecimal++) {
                    const element = numberPart[index];
                    const by3 = indexDecimal % 3;

                    newStr = element + newStr;

                    if (by3 === 0 && index !== 0)
                        newStr = thousands + newStr;                    
                }              

                let decimalPart = str[1];
                if (decimalPart) {
                    decimalPart = decimalPart.padEnd(2, '0');
                }

                
                return (this.hasPrefix === false ? '' : prefix ) + newStr + decimal + (decimalPart || '00');
            },
            set(val) {                               
                
                let newValue = 0;
                
                let str = '';
                if (val)
                    str = String(val.replace(/[^\d]+/g, ''));               


                if (str) {
                    str = String(parseInt(str));
                    if (str.length < 3) {
                        str = str.padStart(3, '0');
                    }

                    str = str.substring(0, str.length - 2) + '.' + str.substring(str.length - 2, str.length);

                    newValue = parseFloat(str);
                }

                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        format(e) {            
            if (e.keyCode < 48 || e.keyCode > 57)
                e.preventDefault();
            return;            
        }
    }
}
</script>

